import { ReactNode, useContext } from "react";

import { UserContext } from "../../providers/user-provider";

type Props = {
  children?: ReactNode;
};

export default function UserRole(props: Props): any {
  const { children } = props;
  const { me } = useContext(UserContext);

  if (!me) {
    return;
  }

  return children;

  // Note(john): tmp disabled because I have no admin permissions.
  // return me.isAdmin ? children : undefined;

  // ToDo: Add permission check
  // return allowedUserRoles.includes(me.permissions) ? children : undefined;
}
